export { PromocodeLanding } from './promocode-landing';
